var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      directives: [
        {
          name: "track",
          rawName: "v-track:click",
          value: { axId: _vm.axId, axType: "button" },
          expression: "{ axId: axId, axType: 'button' }",
          arg: "click"
        }
      ],
      class: { "plan-button": true, "subpack-plan": _vm.subpack },
      attrs: { "data-price-vendor": _vm.priceVendor },
      on: { click: _vm.handleClick }
    },
    [
      _vm.subpack
        ? _c(
            "div",
            { staticClass: "plan-info" },
            [
              _vm._t("plan-name"),
              _vm._v(" "),
              _vm._t("plan-price"),
              _vm._v(" "),
              _vm._t("plan-period")
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.subpack ? _vm._t("plan-name") : _vm._e(),
      _vm._v(" "),
      !_vm.subpack ? _vm._t("plan-price") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }